import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationTriangleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 35 31.3",
	style: { enableBackground: "new 0 0 35 31.3" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.exclamation-triangle-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "exclamation-triangle-icon-st0",
		d: "M34.5,25.7L20.7,1.9c-0.3-0.6-0.8-1-1.4-1.4C18.7,0.2,18.1,0,17.4,0s-1.3,0.2-1.9,0.5s-1,0.8-1.4,1.4 L0.5,25.7C0.2,26.3,0,26.9,0,27.6c0,0.7,0.2,1.3,0.5,1.9c0.3,0.6,0.8,1,1.4,1.4c0.5,0.2,1.2,0.4,1.8,0.4h27.5 c0.7,0,1.3-0.2,1.9-0.5c0.6-0.3,1-0.8,1.4-1.4c0.3-0.6,0.5-1.2,0.5-1.9C35,26.9,34.8,26.2,34.5,25.7z M16.2,12.6 c0-0.3,0.1-0.6,0.4-0.9c0.2-0.2,0.6-0.4,0.9-0.4s0.6,0.1,0.9,0.4c0.2,0.2,0.4,0.6,0.4,0.9v6.2c0,0.3-0.1,0.6-0.4,0.9 s-0.6,0.4-0.9,0.4s-0.6-0.1-0.9-0.4s-0.4-0.6-0.4-0.9V12.6z M17.5,26.3c-0.4,0-0.7-0.1-1-0.3s-0.5-0.5-0.7-0.8 c-0.1-0.3-0.2-0.7-0.1-1.1c0.1-0.4,0.3-0.7,0.5-1s0.6-0.4,1-0.5c0.4-0.1,0.7,0,1.1,0.1c0.3,0.1,0.6,0.4,0.8,0.7 c0.2,0.3,0.3,0.7,0.3,1c0,0.5-0.2,1-0.5,1.3C18.5,26.1,18,26.3,17.5,26.3z"
	}) }) }) })]
});
export default SvgExclamationTriangleIcon;
